import { env } from "@/lib/env";
import { SHOPIFY_CONFIG } from "./config";

// Function to build the login URL for Shopify authentication
export const buildLoginURL = (codeChallenge: string, state: string, nonce: string) => {
  const url = new URL(SHOPIFY_CONFIG.authEndpoint);
  url.searchParams.set("scope", SHOPIFY_CONFIG.scopes);
  url.searchParams.set("client_id", env.NEXT_PUBLIC_CUSTOMER_ACCOUNT_CLIENT_ID);
  url.searchParams.set("response_type", SHOPIFY_CONFIG.responseType);
  url.searchParams.set("redirect_uri", env.NEXT_PUBLIC_BASE_URL + SHOPIFY_CONFIG.redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("nonce", nonce);
  url.searchParams.set("code_challenge", codeChallenge);
  url.searchParams.set("code_challenge_method", SHOPIFY_CONFIG.codeChallengeMethod);
  return url.toString();
};

// Function to build the logout URL for Shopify authentication
export const buildLogoutURL = () => {
  return SHOPIFY_CONFIG.logoutEndpoint
    ? { logoutURL: SHOPIFY_CONFIG.logoutEndpoint }
    : { error: "Logout URL not found" };
};
